import React, { useState } from 'react';
import { Field } from 'formik';
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
const RadioButton = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  defaultValue,
  onSelect,
  disabled,
  disableClass,
  iIconTxt,
  setIndex,
  yesNoValue,
  ...props
}) => {
  if (disabled === undefined) disabled = false;

  let radioLabel = className
  if (className === undefined || className === '') {
    radioLabel = ''
  }

  const [tooltipLocationType, setTooltipLocationType] = useState(false);
  const iIconLocationType = (infoTxt) => {
    return <>
      <img
        id="tooltipLocationType"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipLocationType}
        target="tooltipLocationType"
        toggle={() =>
          setTooltipLocationType(!tooltipLocationType)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }
  const [tooltipCentralizedType, setTooltipCentralizedType] = useState(false);
  const iIconCentralized = (infoTxt) => {
    return (
      <>
        <img
          id="tooltipCentralizedType"
          src={information}
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-1px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipCentralizedType}
          target="tooltipCentralizedType"
          toggle={() => setTooltipCentralizedType(!tooltipCentralizedType)}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  }
  const [tooltipHybridType, setTooltipHybridType] = useState(false);
  const iIconHybridType = (infoTxt) => {
    return <>
      <img
        id="tooltipHybridType"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipHybridType}
        target="tooltipHybridType"
        toggle={() =>
          setTooltipHybridType(!tooltipHybridType)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  return (
    <div className="radioField">
      <label className={`${radioLabel} radio-container`} htmlFor={id}>
        <span>
          {label}
          {iIconTxt && <>
            {setIndex === 0 && yesNoValue !== "CreditCard" && iIconLocationType(
              iIconTxt[setIndex].toolTip
            )}
            {setIndex === 1 &&
              iIconCentralized(
                iIconTxt[setIndex].toolTip
              )}
            {setIndex === 2 &&
              iIconHybridType(
                iIconTxt[setIndex].toolTip
              )}
          </>}
        </span>
        <input
          name={name}
          id={id}
          type="radio"
          value={id}
          checked={(id === "endBy" || id === "endAfter") ? id === defaultValue : id === value}
          onChange={onChange}
          disabled={name === "reseller" ? false : disabled}
          onClick={(e) => {
            onSelect(e, props);
          }}
          onBlur={onBlur}
          {...props}
        />
        {name === "reseller" && disabled && <span className={`radio-checkmark`}></span>}
        {name === "seller" && disabled && <span className={`radio-checkmarkDisabled`}></span>}
        {name === "buyer" && disabled && <span className={`radio-checkmarkDisabled`}></span>}
        {!disabled && <span className={`radio-checkmark`}></span>}
        {name !== "reseller" && name !== "postingRadioDisable" && name !== "seller" && name !== "buyer" && disabled && <span className={`radio-checkmark`}></span>}
        {(name === "postingRadioDisable" || name === 'postingPlacePreference') && disabled && <span className={`radio-postDisabled`}></span>}
      </label>
    </div>
  );
};

export default RadioButton;
